import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  height: 100%;
  padding-top: 12px;
  overflow: hidden;
`;

export const TabContent = styled.div`
  flex: 1;
  min-height: 0;
  position: relative;
`;

export const StaticPart = styled.div`
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  padding-right: 16px;
  padding-left: 16px;
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: ${theme.colors.secondary900};
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
